
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 10 10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.088 6.375c.141-.208.245-.43.312-.662a2.581 2.581 0 00-.081-1.657 2.377 2.377 0 00-.544-.831 2.33 2.33 0 00-.819-.538 2.58 2.58 0 00-.931-.174l.475-.488-.525-.525L3.55 2.913l1.425 1.412L5.5 3.8l-.55-.55c.225 0 .454.044.688.131.233.088.433.215.6.382.166.166.293.358.38.575a1.655 1.655 0 01.075 1.075 2.15 2.15 0 01-.155.412l.55.55zM5.024 8.5L6.45 7.088 5.025 5.675 4.5 6.2l.537.537c-.233.009-.46-.029-.68-.112a1.665 1.665 0 01-.595-.388 1.712 1.712 0 01-.38-.575 1.655 1.655 0 01-.075-1.075c.037-.141.089-.279.155-.412l-.55-.55c-.141.208-.245.43-.312.662a2.476 2.476 0 00.087 1.65c.126.309.309.584.55.825.242.242.513.423.813.544.3.121.608.186.925.194l-.475.475.525.525zM5 10a5.071 5.071 0 01-1.975-.381 4.88 4.88 0 01-1.587-1.056A4.88 4.88 0 01.38 6.974 5.071 5.071 0 010 5c0-.7.127-1.354.381-1.962A4.88 4.88 0 013.025.388 5 5 0 015 0a4.968 4.968 0 013.55 1.45A4.968 4.968 0 0110 5a5 5 0 01-1.45 3.563c-.45.45-.98.802-1.588 1.056A5.039 5.039 0 015 10zm0-.75c1.208 0 2.219-.406 3.031-1.219C8.844 7.22 9.25 6.208 9.25 5c0-1.208-.406-2.219-1.219-3.031C7.22 1.156 6.208.75 5 .75c-1.208 0-2.219.406-3.031 1.219C1.156 2.78.75 3.792.75 5c0 1.208.406 2.219 1.219 3.031C2.78 8.844 3.792 9.25 5 9.25z","fill":"#787878"}})])
          )
        }
      }
    